﻿package org.zq.pixelset.platform

import org.zq.pixelset.model.SavedAppSettings
import kotlinx.browser.localStorage

private const val STORAGE_KEY = "pixelset_settings"

actual object SettingsStore {
    actual fun load(): SavedAppSettings? =
        SavedAppSettings.decode(localStorage.getItem(STORAGE_KEY))

    actual fun save(settings: SavedAppSettings) {
        localStorage.setItem(STORAGE_KEY, settings.encode())
    }
}
